export default "__VITE_ASSET__yWMqaUxH__"